import axios from "axios";
import {
  BACKEND_SERVER_URL,
  trafficUserTokenName,
  superAdminTokenName,
  policeTokenName,
  fireTokenName,
  pwdTokenName,
  ngrrachanaTokenName,
} from "./config";

export const server = axios.create({
  baseURL: BACKEND_SERVER_URL,
  proxy: BACKEND_SERVER_URL,
});

export const removeSuperAdminToken = () => {
  return sessionStorage.removeItem(superAdminTokenName);
};

export const removeNagarUserToken = () => {
  return sessionStorage.removeItem(ngrrachanaTokenName);
};

export const removeTrafficUserToken = () => {
  return sessionStorage.removeItem(trafficUserTokenName);
};

export const removeDiviOfficeUserToken = () => {
  return sessionStorage.removeItem(trafficUserTokenName);
};

export const removePoliceUserToken = () => {
  return sessionStorage.removeItem(policeTokenName);
};

export const removeFireUserToken = () => {
  return sessionStorage.removeItem(fireTokenName);
};

export const removePWDUserToken = () => {
  return sessionStorage.removeItem(pwdTokenName);
};

// export const getIndustryUserToken = () => {
//   return sessionStorage.setItem(industryUserTokenName);
// };

export const blobToFile = (data) => {
  return data ? window.URL.createObjectURL(data) : null;
};

export const truncateText = (text, limit) => {
  const words = text.split(" ");
  if (words.length > limit) {
    return words.slice(0, limit).join(" ") + " ...";
  }
  return text;
};

// Divyang admin panel user models
// export const statusMessage = (item, role) => {
//   switch (role) {
//     case "Super Admin":
//       return item?.permission_status;
//     case "Traffic":
//       return item?.statusbytraffic;
//     case "Division Officer":
//       return item?.statusbydivision;
//     case "Police Department":
//       return item?.statusbypolice;
//     case "Fire Department":
//       return item?.statusbyfire;
//     case "PWD Department":
//       return item?.statusbypwd;
//     case "Nagar Department":
//       return item?.statusbynagarrachana;
//     default:
//       return "No Status Available";
//   }
// };
export const statusMessage = (item, role) => {
  switch (role) {
    case "Super Admin":
      // Final status for super admin only
      return item?.permission_status || "PENDING";

    case "Division Officer":
      // Division Officer la fakta tyacha khudach status disava
      return item?.statusbydivision || "PENDING";

    case "Traffic":
      return item?.statusbytraffic || "PENDING";

    case "Police Department":
      return item?.statusbypolice || "PENDING";

    case "Fire Department":
      return item?.statusbyfire || "PENDING";

    case "PWD Department":
      return item?.statusbypwd || "PENDING";

    case "Nagar Department":
      return item?.permission_status || "PENDING";

    default:
      return "No Status Available";
  }
};

export const statusMessageforButton = (data, role) => {
  switch (role) {
    case "Traffic":
      return data?.statusbytraffic === "APPROVED" ? "Approved" : "Approve";
    case "Division Officer":
      return data?.statusbydivision === "APPROVED" ? "Approved" : "Approve";
    case "Police Department":
      return data?.statusbypolice === "APPROVED" ? "Approved" : "Approve";
    case "Fire Department":
      return data?.statusbyfire === "APPROVED" ? "Approved" : "Approve";
    case "PWD Department":
      return data?.statusbypwd === "APPROVED" ? "Approved" : "Approve";
    case "Nagar Department":
      return data?.statusbynagarrachana === "APPROVED" ? "Approved" : "Approve";
    case "Super Admin":
      return data?.permission_status === "APPROVED" ? "Approved" : "Approve";
    default:
      return "No Status Available";
  }
};
